import classNames from 'classnames';
import { Icon } from 'src/types';

type BaseProps = {
  iconPrefix?: Icon;
  iconSuffix?: Icon;
  block?: boolean;
  animate?: boolean;
  className?: string;
  children: React.ReactNode;
};

type ButtonProps = BaseProps & {
  as: 'button';
  type?: 'button' | 'submit';
  disabled?: boolean;
  ref?: React.Ref<HTMLButtonElement>;
  onClick?: () => void;
};

type LinkProps = BaseProps & {
  as?: 'link';
  href?: string;
  openInNewWindow?: boolean;
  onClick?: () => void;
};

const AnchorLink = (props: ButtonProps | LinkProps) => {
  const { block, className } = props;

  const wrapperClasses = classNames({
    block,
    'inline-block': !block,
  });

  const classes = classNames(
    'relative font-semibold text-lg text-primary-500 disabled:text-primary-300 group cursor-pointer',
    {
      'inline-block': block,
    },
    className
  );

  if (props.as === 'button') {
    const { onClick, type = 'button', disabled } = props;

    return (
      <span className={wrapperClasses}>
        <button type={type} className={classes} onClick={onClick} disabled={disabled}>
          <Content {...props} />
        </button>
      </span>
    );
  }

  const { onClick, href, openInNewWindow } = props;

  return (
    <span className={wrapperClasses}>
      <a
        className={classes}
        href={href}
        target={openInNewWindow ? '_blank' : undefined}
        rel="noreferrer"
        onClick={onClick}
      >
        <Content {...props} />
      </a>
    </span>
  );
};

const Content = ({ iconPrefix: IconPrefix, iconSuffix: IconSuffix, animate, children }: BaseProps) => (
  <span
    className={classNames('relative inline-flex items-center gap-x-1.5', {
      'translate-x-0 transition-transform group-hover:translate-x-2': animate,
      'transition-colors group-hover:text-gray-900': !animate,
    })}
  >
    {IconPrefix && <IconPrefix className="stroke-4 text-xl" />}
    {children}
    {IconSuffix && <IconSuffix className="stroke-4 text-xl" />}
  </span>
);

export default AnchorLink;
